
import { ApiPaths } from "../../api/ApiPaths";
import { ApiRequest } from "../../api/ApiRequest";
import { UtilizationDocument } from "../../../domain/utilization_document/UtilizationDocument";

export type GetUtilizationDocumentSuccessResponseType = {
    utilizationDocuments: UtilizationDocument[],
    // API処理結果判別用：OK->undefined、NG->ErrorResponseType
    error: undefined
}

export async function getUtilizationDocuments(): Promise<GetUtilizationDocumentSuccessResponseType> {
    return await ApiRequest.get(
        ApiPaths.utilizationDocument.list,
        {},
        () => {},
        () => {});
}

export async function uploadUtilizationDocument(acceptedFile: any): Promise<any> {
    const formData = new FormData();
    formData.append("file", acceptedFile);
    // ApiRequest.postはbodyをJSON.stringfyしているので、直接fetchを呼び出す。
    const result = await fetch(ApiPaths.utilizationDocument.upload, {
        method: "POST",
        body: formData,
    });
    return result;
}

export async function deleteUtilizationDocument(objectName: string): Promise<any> {

    return await ApiRequest.delete(
        ApiPaths.utilizationDocument.delete.replace(/\{objectName\}/, objectName),
        { objectName: objectName },
        () => {},
        () => {}
    );
}
